export abstract class LoaderService {
    loadingCnt: number;
    abstract loading(promise: angular.IPromise<any> | Promise<any>): angular.IPromise<any>;
}

export function LoaderServiceFactory($injector: angular.auto.IInjectorService) {
    return $injector.get('Loader');
}

export const LoaderServiceProvider = {
    provide: LoaderService,
    useFactory: LoaderServiceFactory,
    deps: ['$injector']
};
